
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initPerformanceMonitoring } from './utils/performanceMonitoring';

// Start performance monitoring
initPerformanceMonitoring();

// Mark application initialization
performance.mark('app-init');

// Render the app
createRoot(document.getElementById("root")!).render(<App />);

// Mark application mounted
performance.mark('app-mounted');
performance.measure('app-init-to-mount', 'app-init', 'app-mounted');
